module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lote-leilao-stats"
  }, [_c('div', {
    staticClass: "tab-lance-numlote"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_vm._v("Lote")]), _vm._v(" "), _c('div', {
    staticClass: "stats-input"
  }, [_vm._v(_vm._s(_vm.loteNumero))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-lance-timer"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_vm._v("Tempo")]), _vm._v(" "), _c('div', {
    staticClass: "stats-input lance-timer",
    class: {
      'lance-danger': _vm.countDownTimer <= _vm.calcPercentTimer(30)
    }
  }, [_vm._v("\n      " + _vm._s(_vm.timerPregaoFormatado) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-valor-atual",
    class: _vm.minimoStyle
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_vm._v("Valor atual")]), _vm._v(" "), _c('div', {
    staticClass: "stats-input valor-atual",
    class: {
      novoLance: _vm.hasNovoLance
    }
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-ultimo-lance"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_vm._v("Último lance")]), _vm._v(" "), _c('div', {
    staticClass: "stats-input ultimo-lance"
  }, [_c('div', [_vm._v("\n        " + _vm._s(_vm.apelido) + "\n        "), _c('span', [_vm._v(_vm._s(_vm.lanceLocalidade))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-status"
  }, [_c('div', {
    staticClass: "stats-title"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "stats-input lote-status s-pregao"
  }, [_c('span', {
    style: ('color: ' + _vm.colorStatus)
  }, [_vm._v(_vm._s(_vm.statusLote))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63bea389","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/LoteLeilaoStats.vue
// module id = 1717
// module chunks = 17